import { HttpInterceptorFn, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, mergeMap, of, throwError } from 'rxjs';
import { AuthService } from '../_services/auth.service';
import { modaleErrore } from '../modali/modale-errore/modale-errore.component';
import { _ } from '@ngx-translate/core';


export const errorInterceptor: HttpInterceptorFn = (req, next) => {
	const authService = inject(AuthService);
	const modalService = inject(NgbModal);
	return next(req).pipe(
		mergeMap((response) => {
			if (response instanceof HttpResponse) {
				const body = response.body as { esito?: 'OK' | 'KO'; result?: any; descrizione?: string };
				if (body && body.esito) {
					// se esito è KO, mostra il messaggio d'errore che arriva
					if (body.esito === 'KO') {
						modaleErrore(modalService, _('Errore'), body.descrizione || _('ErroreGenerico'));
						return throwError(() => new Error(body.descrizione || 'KO'));
					}

					// se esito è OK, rimanda il result
					return of(response.clone({ body: body }));
				}
			}
			return of(response);
		}),
		catchError((error: any) => {
			if (error instanceof HttpErrorResponse) {
				switch (error.status) {
					/* Sessione scaduta o login fallito */
					case 401:
						if (authService.isAuthenticated) {
							modaleErrore(modalService, _('Attenzione'), _('SessioneScadutaError'));
							authService.logout();
						} else {
							modaleErrore(modalService, _('Attenzione'), _('CredentialiErrateError'));
						}
						break;
					case 400:
							modaleErrore(modalService, _('Attenzione'), _('ErroreBadRequest'));
						break;
					/* Errore con messaggio gestito dal BackEnd */
					case 409:
						modaleErrore(modalService, _('Attenzione'), error.error?.message || error.error || _('ErroreGenerico'));
						break;
					/* Accesso ad una risorsa non consentito dai permessi dell' utente */
					case 403:
						modaleErrore(modalService, _('Attenzione'), _('AutorizzazioneNegataError'));
						break;
					/* Errore di rete o richiesta interrotta (es. abort dovuto alla navigazione indietro da mobile dopo l'apertura di un PDF): error.error è un ProgressEvent, non un messaggio.
					   Non mostriamo una modale: non è un errore azionabile dall'utente e interromperebbe flussi (es. download documenti) che possono proseguire senza intervento. */
					case 0:
						break;
					default:
						modaleErrore(modalService, 'Errore', typeof error.error?.message === 'string' ? error.error.message : typeof error.error === 'string' ? error.error : _('ErroreGenerico'), error);
						break;
				}
			}
			return throwError(error);
		}),
	);
};
